import config from 'config/default'

const { baseUrl } = config

/**
 * 获取某一课程主题的所有讲师
 * @param theme
 */
export const getPresenter = async theme => {
    const url = `${baseUrl}/data/presenter/${theme}.json`
    return await fetch(url)
        .then(resp => resp.json())
        .catch(() => null)
}